import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "../css/TopBar.css";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedModel, setSelectedMode ,setModelDetails} from "../redux/modelSlice";
import { setSearchTerm } from "../redux/chatSlice";
import api from "../api";
import { fetchUnreadCount } from "../redux/notificationSlice";
import {
  resetSidebarState,
  setSelectedMenu,
  setRefreshSidebar,
} from "../redux/sidebarSlice";
import ModeSelector from "./ModeSelector"; // path change as needed
import { setIsChatPage } from "../redux/sessionSlice"; // adjust path as needed
import { setPrivacyMode } from "../redux/privacySlice";
import {
  showSuccessToast,
  showErrorToast,
  showInfoToast,
} from "../utils/toastUtils";
import "react-toastify/dist/ReactToastify.css";
import { TOAST_MESSAGES } from "../utils/toastMessages";
import GreenSymbol from "../assets/Images/Green_Symbol.png";
import RedSymbol from "../assets/Images/Red_Symbol.png";

// Icons
import sharIcon from "../assets/UserIcons/ShareChatIcon.svg";
import notificationIcon from "../assets/UserIcons/Notification.svg";
import profileIcon from "../assets/Images/ProfileIcon.png";
import searchIcon from "../assets/UserIcons/Search.svg";
import settingIcon from "../assets/UserIcons/Setting.svg";
import helpIcon from "../assets/UserIcons/GetHelp.svg";
import logoutIcon from "../assets/UserIcons/Logout.svg";
import crossIcon from "../assets/UserIcons/Cancel.svg";
import likeIcon from "../assets/Images/like.svg";
import onlineIcon from "../assets/UserIcons/OnlineMode.svg";
import offlineIcon from "../assets/UserIcons/OfflineModeBlack.svg";
import mailIcon from "../assets/icons/mailIcon.png";

const TopBar = ({ sidebarExpanded, toggleSidebar }) => {
  const dispatch = useDispatch();
  const isFullPrivacy = useSelector((state) => state.privacy.isFullPrivacy);
  const navigate = useNavigate();
  const location = useLocation();
  const profileMenuRef = React.useRef(null);

  const [models, setModels] = useState([]);
  const [modelList, setModelList] = useState([]);
  const [showTooltip, setShowTooltip] = useState(null);
  const reversedModelList = modelList.slice().reverse();
  const selectedMenu = useSelector((state) => state.sidebar.selectedMenu);

  const selectedModel = useSelector((state) => state.model.selectedModel);
  const sessionId = useSelector((state) => state.session.sessionId);

  const { isChatPage } = useSelector((state) => state.session);

  const [showShareModal, setShowShareModal] = useState(false);
  const [generatedLink, setGeneratedLink] = useState("");
  const [copyStatus, setCopyStatus] = useState("idle");
  const [showMailIcon, setShowMailIcon] = useState(false);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [showModelConfirmation, setShowModelConfirmation] = useState(false);
  const [selectedModelDetails, setSelectedModelDetails] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const unreadCount = useSelector((state) => state.notifications.unreadCount);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [user, setUser] = useState(null);

  const refreshKey = useSelector((state) => state.refresh.key);

  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [backendLastModel, setBackendLastModel] = useState(null);
  const [isModelRestored, setIsModelRestored] = useState(false);
  const [isMobileSearchOpen, setIsMobileSearchOpen] = useState(false);

  const isMobile = window.innerWidth <= 480;

  const handleMenuClick = (label) => {
    dispatch(setSelectedMenu(label));
  };

  useEffect(() => {
    if (modelList.length === 0) return;

    let matchedModel = null;

    // Only restore once
    if (!isModelRestored && backendLastModel) {
      const backendModelId =
        backendLastModel.id || backendLastModel.model_details?.model_id;

      matchedModel = modelList.find((m) => m.id === backendModelId);

      if (matchedModel) {
        setSelectedModelDetails(matchedModel);
        dispatch(setSelectedModel(matchedModel.id));
        setIsModelRestored(true);
        // console.log("🤖 Restored model:", matchedModel.name);
        return;
      }
    }

    // If user selected manually, DO NOT override
    if (selectedModel && !matchedModel) {
      matchedModel = modelList.find((m) => m.id === selectedModel);
    }

    if (!matchedModel) {
      matchedModel = modelList[0];
    }

    setSelectedModelDetails(matchedModel);
    dispatch(setSelectedModel(matchedModel.id));
  }, [modelList, backendLastModel, selectedModel, dispatch]);

  const handleTogglePrivacy = () => {
    setShowPrivacyModal(true);
  };

  // ✅ Keep sidebar title in sync with current route
  useEffect(() => {
    const path = location.pathname;

    if (path.includes("/user/new") || path.includes("/chat")) {
      dispatch(setSelectedMenu("New Chat"));
    } else if (path.includes("/learning-space")) {
      dispatch(setSelectedMenu("Learning Space"));
    } else if (path.includes("/knowledgerepository-documents")) {
      dispatch(setSelectedMenu("Knowledge Repository"));
    } else if (path.includes("/knowledgespace-saved")) {
      dispatch(setSelectedMenu("My Knowledge Space"));
    } else if (path.includes("/notifications")) {
      dispatch(setSelectedMenu("Notifications"));
    } else if (path.includes("/profile")) {
      dispatch(setSelectedMenu("Settings"));
    } else if (path.includes("/getHelpPage")) {
      dispatch(setSelectedMenu("Get Help"));
    } else {
      dispatch(setSelectedMenu(""));
    }
  }, [location.pathname, dispatch]);

  // 🔹 Automatically update Redux based on route
  useEffect(() => {
    if (location.pathname.startsWith("/chat")) {
      dispatch(setIsChatPage(true));
    } else {
      dispatch(setIsChatPage(false));
    }
  }, [location.pathname, dispatch]);

  const token =
    localStorage.getItem("access_token") ||
    sessionStorage.getItem("access_token");

  const [preferences, setPreferences] = useState({
    notifications: {
      notifications_all: true,
      message_alerts: "Instant",
      session_reminders: false,
    },
  });

  const fetchPreferences = async () => {
    try {
      const res = await api.get(
        `${process.env.REACT_APP_API_URL}/user-profile/preferences`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      // console.log(res.data.preferences.last_selected_model, "idahhdjkdhids");

      dispatch(setPrivacyMode(res.data?.privacy_mode));

      // if(res.data?.privacy_mode){

      //     console.log(res.data.preferences.last_selected_model, "idahhdjkdhids")
      // }

      if (res.data?.preferences) {
        setPreferences(res.data.preferences);
        setBackendLastModel(res.data.last_selected_model);
        // store temporarily
        // console.log(
        //   res.data.preferences.last_selected_model,
        //   "idahhdjkdhids"
        // );
      }

      // Apply theme
      if (res.data?.theme_mode) {
        const isDark = res.data.theme_mode === "dark";
        setDarkMode(isDark);
        localStorage.setItem("darkMode", isDark);
        document.documentElement.setAttribute(
          "data-theme",
          isDark ? "dark" : "light"
        );
      }
    } catch (err) {
      console.error("❌ Error fetching preferences:", err);
    }
  };

  // 1️⃣ Fetch preferences (once)
  useEffect(() => {
    fetchPreferences();
  }, [refreshKey, token]);

  const [darkMode, setDarkMode] = useState(
    localStorage.getItem("darkMode") === "true"
  );

  const handleSearchChange = (e) => {
    dispatch(setSearchTerm(e.target.value));
  };

  // 🔁 Fetch Document Chat Models
  useEffect(() => {
    if (!location.pathname.includes("/chat/document")) return;

    const fetchDocumentModels = async () => {
      const token =
        localStorage.getItem("access_token") ||
        sessionStorage.getItem("access_token");

      try {
        const res = await api.get(
          `${process.env.REACT_APP_API_URL}/uploaded-files/models`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        const modelsArray = Array.isArray(res.data.models)
          ? res.data.models
          : [];
        setModels(modelsArray);

        if (modelsArray.length > 0 && !selectedModel) {
          const defaultModel = modelsArray.find(
            (m) => m.name === "llama-3.1-70b-versatile"
          );
          dispatch(setSelectedModel(defaultModel?.id || modelsArray[0].id));
        }
      } catch (err) {
        console.error("Failed to fetch document models:", err);
        setModels([]);
      }
    };

    fetchDocumentModels();
  }, [dispatch, location.pathname, selectedModel]);

  useEffect(() => {
    const fetchEnterpriseModels = async () => {
      // console.log("%c🔍 Fetching Enterprise Models...", "color: #4CAF50");

      try {
        const res = await api.get(
          `${process.env.REACT_APP_API_URL}/enterprise-admin-setting/approved`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        // console.log("📥 API Raw Response:", res.data);

        // Fallback Models if API returns nothing
        const fallbackModels = [
          {
            model_id: "llama-3.2-1b-instruct-q4_k_m",
            model_name: "Llama3.2",
            model_type: "offline",
            model_generic_name: "Llama3.2",
            model_icon: "",
            model_parameter: "1B",
          },
          {
            model_id: "llama-3.3-70b-versatile",
            model_name: "Llama-3.3-70B",
            model_type: "online",
            model_generic_name: "Llama-3.3-70B",
            model_icon: "",
            model_parameter: "70B",
          },
        ];

        let allModels = [];

        // ---- STEP 1: If API gives valid models, map them ----
        if (res.data?.data?.length > 0) {
          allModels = res.data.data
            .map((m) => {
              const detail = m.model_details;
              return detail
                ? {
                    id: detail.model_id,
                    name: detail.model_name,
                    model_icon: detail.model_icon,
                    model_generic_name: detail.model_generic_name,
                    model_type: detail.model_type?.toLowerCase(),
                    model_parameter: detail.model_parameter,
                    model_details: detail,
                  }
                : null;
            })
            .filter(Boolean);

          // console.log("📦 Models from API:", allModels);
        }

        // ---- STEP 2: If API returned nothing → use fallback ----
        if (allModels.length === 0) {
          console.warn("⚠ No models returned from API → using fallback models");
          allModels = fallbackModels.map((m) => ({
            id: m.model_id,
            name: m.model_name,
            model_icon: m.model_icon,
            model_generic_name: m.model_generic_name,
            model_type: m.model_type,
            model_parameter: m.model_parameter,
            model_details: m,
          }));
        }

        setModelList(allModels);

        // console.log("✅ Final Model List (online + offline):", allModels);

        // ---- STEP 3: Auto select highest model ----
        const getParamValue = (param) => {
          if (!param) return 0;
          const match = param.toLowerCase().match(/(\d+)\s*b/);
          return match ? parseInt(match[1]) : 0;
        };

        const topModel = allModels.reduce((max, curr) =>
          getParamValue(curr.model_parameter) >
          getParamValue(max.model_parameter)
            ? curr
            : max
        );

        // console.log("🎯 Top Model Selected:", topModel);

        const existingModel = allModels.find((m) => m.id === selectedModel);

        if (existingModel) {
          setSelectedModelDetails(existingModel);
          // console.log("📌 Using Previously Selected Model:", existingModel);
        } else {
          dispatch(setSelectedModel(topModel.id));
          setSelectedModelDetails(topModel);
          // console.log("📌 Auto-selected Model:", topModel);
        }
      } catch (err) {
        console.error("❌ Error fetching enterprise models:", err);
      }
    };

    fetchEnterpriseModels();
  }, [location.pathname, token, dispatch, refreshKey, isFullPrivacy]);

  const handleLogout = async () => {
    try {
      // ✅ Call backend logout API
      await api.post(
        `${process.env.REACT_APP_API_URL}/auth/logout-device`,

        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );

      // ✅ Clear localStorage & sessionStorage
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("user");
      // 1️⃣ Reset dark mode
      setDarkMode(false);
      localStorage.setItem("darkMode", false);
      document.documentElement.setAttribute("data-theme", "light");

      // ✅ Reset Redux / UI state
      dispatch(resetSidebarState());

      // ✅ Show success toast
      showSuccessToast(
        "You have been logged out successfully. Have a great day!"
      );

      // ✅ Redirect to login page
      navigate("/");
    } catch (err) {
      console.error("Logout failed:", err);
      // Optional: show toast/error notification to user
      // ❌ Show error toast
      showErrorToast("Logout failed. Please try again.");
    }
  };

  useEffect(() => {
    dispatch(fetchUnreadCount());
  }, [dispatch]);

  const handleShareSession = async () => {
    if (!sessionId) return console.log("Session ID not available!");

    const token =
      localStorage.getItem("access_token") ||
      sessionStorage.getItem("access_token");

    try {
      await api.post(
        `${process.env.REACT_APP_API_URL}/chat/share-session`,
        { session_id: sessionId },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const shareURL = `${process.env.REACT_APP_API}/chat/shared/${sessionId}`;
      setGeneratedLink(shareURL);
      setShowShareModal(true);
    } catch (error) {
      console.error("Error sharing session", error);
      showErrorToast(
        "Unable to share requested session. Please try again later."
      );
    }
  };

  const handleModelSelectWithModal = async (model) => {
    try {
      // Determine privacy mode based on model type
      const privacy_mode = model.model_type === "online" ? false : true;

      // Update backend with both selected model and privacy_mode
      await updateUserPreferences({
        last_selected_model: model,
        privacy_mode,
      });

      // 🔥 FIRST fetch updated user preferences always
      await fetchPreferences();

      // Update frontend state
      dispatch(setPrivacyMode(privacy_mode));
      setSelectedModelDetails(model);
      dispatch(setSelectedModel(model.id));
      dispatch(setModelDetails(model));       // FULL object
    } catch (error) {
      console.error("❌ Failed to select model:", error);
      // Optionally show error toast
      // showErrorToast("Failed to select model. Please try again.");
    }
  };

  useEffect(() => {
    document.documentElement.setAttribute(
      "data-theme",
      darkMode ? "dark" : "light"
    );
  }, [darkMode]);

  const toggleProfileMenu = () => {
    setShowProfileMenu((prev) => {
      if (!prev) {
        // Opening → add outside click listener
        document.addEventListener("mousedown", handleOutsideClick);
      } else {
        // Closing → remove listener
        document.removeEventListener("mousedown", handleOutsideClick);
      }
      return !prev;
    });
  };

  const handleOutsideClick = (event) => {
    if (
      profileMenuRef.current &&
      !profileMenuRef.current.contains(event.target)
    ) {
      setShowProfileMenu(false);
      document.removeEventListener("mousedown", handleOutsideClick);
    }
  };

  const closeMenu = () => {
    setShowProfileMenu(false);
    document.removeEventListener("mousedown", handleOutsideClick);
  };

  useEffect(() => {
    document.body.classList.toggle("dark-mode", darkMode);
    localStorage.setItem("theme", darkMode ? "dark" : "light");
  }, [darkMode]);

  useEffect(() => {
    const dropdowns = document.querySelectorAll(".dropdown-toggle");

    dropdowns.forEach((btn) => {
      btn.addEventListener("click", () => {
        dropdowns.forEach((otherBtn) => {
          if (otherBtn !== btn) {
            const menu = otherBtn.nextElementSibling;
            if (menu && menu.classList.contains("show")) {
              menu.classList.remove("show");
            }
          }
        });
      });
    });

    return () => {
      dropdowns.forEach((btn) => {
        btn.removeEventListener("click", () => {});
      });
    };
  }, []);

  // ✅ Fetch user profile from API
  useEffect(() => {
    const token1 = sessionStorage.getItem("access_token");

    const fetchUserProfile = async () => {
      try {
        const res = await api.get(
          `${process.env.REACT_APP_API_URL}/user-profile/profile`,
          {
            headers: { Authorization: `Bearer ${token1}` },
          }
        );

        setUser(res.data);
      } catch (err) {
        console.error("Failed to fetch user profile:", err);
      }
    };

    if (token) fetchUserProfile();
  }, [token, refreshKey]);

  const userRoleName = localStorage.getItem("role_name");

  // ✅ Unified function to call backend for updating preferences
  const updateUserPreferences = async (payload) => {
    try {
      const res = await api.put(
        `${process.env.REACT_APP_API_URL}/user-profile/preferences`,
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (res.status === 200) {
        // 🎨 Theme
        if (payload.theme_mode) {
          showSuccessToast(`Theme changed to ${payload.theme_mode}.`);
        }

        // 🧠 Mode type
        else if (payload.mode_type) {
          showSuccessToast(`Mode changed to ${payload.mode_type}.`);
        }

        // 🤖 Last selected model
        else if (payload.last_selected_model) {
          showSuccessToast(
            `Model set: ${
              payload.last_selected_model.model_generic_name ||
              payload.last_selected_model.name
            }`
          );
        }

        // General fallback toast
        else {
          // showSuccessToast("Preferences updated successfully.");
        }
      }
    } catch (error) {
      console.error("❌ Failed to update user preferences:", error);
      // showErrorToast("Failed to update preferences. Please try again.");
    }
  };

  // ✅ Toggle Dark/Light Mode
  const toggleDarkMode = async () => {
    setDarkMode((prev) => {
      const newMode = !prev;
      const theme = newMode ? "dark" : "light";

      // Save locally
      localStorage.setItem("darkMode", newMode);
      document.documentElement.setAttribute("data-theme", theme);

      // 🔹 Call backend to persist the theme mode
      updateUserPreferences({ theme_mode: theme });

      return newMode;
    });
  };

  return (
    <div>
      <nav className="navbar navbar-expand-lg px-3 shadow-sm d-flex justify-content-between align-items-center">
        {/* ================= MOBILE SEARCH MODE ================= */}
        {isMobile && isMobileSearchOpen ? (
          <div className="d-flex align-items-center w-100 gap-2">
            {/* Back Button */}
            <button
              className="btn p-0 border-0"
              onClick={() => setIsMobileSearchOpen(false)}
              style={
                {
                  color:"var(--dark-color)"
                }
              }
            >
              <i className="bi bi-arrow-left fs-4"></i>
            </button>

            {/* Search Input */}
            <div className="input-group flex-grow-1">
              <span className="input-group-text"
              style={{border:"1px solid var(--dark-color)"}}>
                <img
                  src={searchIcon}
                  alt="search"
                  className="icon-image"
                  style={{ width: "18px", height: "15px" }}
                />
              </span>
              <input
                type="text"
                className="form-control "
                placeholder="Search For Chats"
                autoFocus
                onChange={handleSearchChange}
              />
            </div>
          </div>
        ) : (
          <div className="d-flex align-items-center gap-1 justify-content-between w-100">
            <div className="d-sm-none me-3">
              <button className="btn p-0 border-0" onClick={toggleSidebar}>
                <i className="bi bi-list fs-3 textblack"></i>
              </button>
            </div>

            {/* --- Topbar Left Section --- */}
            <div className="topbar-left">
              {selectedMenu === "New Chat" ? (
                <div className="dropdown refresh-prompts">
                  <button
                    className="btn btn-outline-secondary rounded-3 dropdown-toggle"
                    type="button"
                    id="modelDropdown"
                    data-bs-toggle="dropdown"
                  >
                    {selectedModelDetails ? (
                      <>
                        {/* Online / Offline icon */}
                        <img
                          src={
                            selectedModelDetails.model_type === "online"
                              ? onlineIcon
                              : offlineIcon
                          }
                          alt="mode-icon"
                          style={{ width: "20px", height: "18px" }}
                          className={
                            selectedModelDetails.model_type === "online"
                              ? "me-3" // Online: normal
                              : "me-3 icon-image1" // Offline: extra class
                          }
                        />

                        {/* Model Name with ellipsis */}
                        <span
                          className="model-text"
                          title={
                            selectedModelDetails.model_generic_name ||
                            selectedModelDetails.name
                          }
                        >
                          {selectedModelDetails.model_generic_name ||
                            selectedModelDetails.name}
                        </span>
                      </>
                    ) : (
                      "Select Model"
                    )}
                  </button>

                  <ul
                    className="dropdown-menu"
                    style={{
                      maxHeight: "225px",
                      width: "260px",
                      overflowY: "auto",
                    }}
                  >
                    {/* ========== ONLINE MODELS ========== */}
                    {modelList
                      .filter((model) => model.model_type === "online")
                      .map((model) => {
                        const isSelected =
                          selectedModelDetails?.id === model.id;
                        return (
                          <li
                            key={model.id}
                            className={`d-flex align-items-center justify-content-between px-2 model-item ${
                              isSelected ? "selected" : ""
                            }`}
                            onClick={() => handleModelSelectWithModal(model)}
                          >
                            <div
                              className="d-flex align-items-center gap-2"
                              style={{ cursor: "pointer", width: "100%" }}
                            >
                              <img
                                src={onlineIcon}
                                alt="onlineIcon"
                                style={{ width: "18px", height: "15px" }}
                              />

                              {/* Custom icon or fallback box icon */}
                              {model.model_icon ? (
                                <img
                                  src={`${process.env.REACT_APP_SERVER_URL}/${model.model_icon}`}
                                  alt="Model Icon"
                                  className="model-icon"
                                />
                              ) : (
                                <i className="bi bi-box-fill fs-5 icon-image1"></i>
                              )}

                              <span
                                className="model-text"
                                title={model.model_generic_name || model.name}
                              >
                                {model.model_generic_name || model.name}
                              </span>
                            </div>

                            <button
                              type="button"
                              className="btn p-0 ms-2 info-btn"
                              title="View details"
                              onClick={(e) => {
                                e.stopPropagation();
                                setSelectedModelDetails(model);
                                setShowModelConfirmation(true);
                              }}
                            >
                              <i className="bi bi-info-circle fs-5"></i>
                            </button>
                          </li>
                        );
                      })}

                    <hr className="my-1" />

                    {/* ========== OFFLINE MODELS ========== */}
                    {modelList
                      .filter((model) => model.model_type === "offline")
                      .map((model) => {
                        const isSelected =
                          selectedModelDetails?.id === model.id;
                        return (
                          <li
                            key={model.id}
                            className={`d-flex align-items-center justify-content-between px-2 model-item ${
                              isSelected ? "selected" : ""
                            }`}
                            onClick={() => handleModelSelectWithModal(model)}
                          >
                            <div
                              className="d-flex align-items-center gap-2"
                              style={{ cursor: "pointer", width: "100%" }}
                            >
                              <img
                                src={offlineIcon}
                                alt="offlineIcon"
                                style={{ width: "18px", height: "15px" }}
                                className="icon-image"
                              />

                              {model.model_icon ? (
                                <img
                                  src={`${process.env.REACT_APP_SERVER_URL}/${model.model_icon}`}
                                  alt="Model Icon"
                                  className="model-icon"
                                />
                              ) : (
                                <i className="bi bi-box fs-5 icon-image1"></i>
                              )}

                              <span
                                className="model-text"
                                title={model.model_generic_name || model.name}
                              >
                                {model.model_generic_name || model.name}
                              </span>
                            </div>

                            <button
                              type="button"
                              className="btn p-0 ms-2 info-btn"
                              title="View details"
                              onClick={(e) => {
                                e.stopPropagation();
                                setSelectedModelDetails(model);
                                setShowModelConfirmation(true);
                              }}
                            >
                              <i className="bi bi-info-circle fs-5"></i>
                            </button>
                          </li>
                        );
                      })}
                  </ul>
                </div>
              ) : (
                <div className="d-flex align-items-center page-title-inline">
                  <h4 className="m-0 fw-bold main-title-inline">
                    {selectedMenu?.split(" - ")[0]}
                  </h4>

                  {selectedMenu?.includes(" - ") && (
                    <span className="sub-title-inline">
                      &nbsp;- {selectedMenu?.split(" - ")[1]}
                    </span>
                  )}
                </div>
              )}
            </div>

            {/* 🔍 Search */}
          {(isChatPage || location.pathname.includes("/chat/document")) && (
            <div className="custom-search-wrapper w-50 m-auto">
              <div className="input-group custom-search-group">
                <span className="input-group-text">
                  {/* <i className="bi bi-search"></i> */}
                  <img
                    src={searchIcon}
                    alt="offlineIcon"
                    style={{ width: "18px", height: "15px" }}
                    className="icon-image"
                  />
                </span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search For Chats"
                  onChange={handleSearchChange}
                />
              </div>
            </div>
          )}

            
            {/* Icons */}
            <div className="d-flex align-items-center gap-2 gap-md-3 ms-auto position-relative">
              {/* Vsible on the chat page */}
              {(isChatPage || location.pathname.includes("/chat/document")) && (
                <button
                  onClick={handleShareSession}
                  className="hi border-0 d-none d-md-block"
                  style={{
                    width: "30px",
                    height: "30px",
                    borderRadius: "50%",
                    backgroundColor: "#F0F0F0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "0",
                    cursor: "pointer",
                  }}
                >
                  <img
                    className=""
                    style={{
                      width: "18px",

                      height: "18px",
                      cursor: "pointer",
                    }}
                    src={sharIcon}
                    alt="share"
                    title="Share"
                  />
                </button>
              )}

              {/* privacy toggle */}
              {/* <button
              className="hi border-0 d-sm-flex"
              onClick={handleTogglePrivacy}
              title={
                isFullPrivacy
                  ? "Switch to Zero Privacy"
                  : "Switch to Full Privacy"
              }
              style={{
                width: "30px",
                height: "30px",
                borderRadius: "50%",
                backgroundColor: "#F0F0F0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "0",
                cursor: "pointer",
              }}
            >
              <img
                src={isFullPrivacy ? GreenSymbol : RedSymbol}
                alt={isFullPrivacy ? "Online" : "Offline"}
                style={{ width: "18px", height: "18px" }}
              />
            </button> */}

            {/* 🔍 MOBILE SEARCH ICON */}
            {(isChatPage || location.pathname.includes("/chat/document")) &&
              isMobile && (
                <button
                  className="btn p-0 border-0"
                  onClick={() => setIsMobileSearchOpen(true)}
                   style={{
                    width: "30px",
                    height: "30px",
                    borderRadius: "50%",
                    backgroundColor: "#F0F0F0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "0",
                    cursor: "pointer",
                  }}
                >
                  <img
                    src={searchIcon}
                    alt="search"
                    style={{ width: "20px", height: "18px" }}
                  />
                </button>
              )}


              {/* ✅ Mode Selector stays in its own area but visible only on New Chat */}
              {selectedMenu === "New Chat" && (
                <div className="mode-selector-container">
                  <ModeSelector />
                </div>
              )}

              {/* theme */}
              <button
                className="hi border-0 d-none d-sm-flex"
                onClick={toggleDarkMode}
                title={darkMode ? "Switch to light." : "Switch to dark."}
                style={{
                  width: "28px",
                  height: "28px",
                  borderRadius: "50%",
                  backgroundColor: "#F0F0F0",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "0",
                  // border: "1px solid #ccc",
                  fontSize: "18px",
                }}
              >
                <i
                  className={`bi ${darkMode ? "bi-sun" : "bi-moon"}`}
                  style={{ fontWeight: "bold" }}
                />
              </button>

              {/* notification button */}
              {preferences.notifications.notifications_all && (
                <Link
                  to="notifications"
                  className="btn text-black p-0 position-relative d-none d-md-flex"
                  title="Notifications"
                  onClick={() => handleMenuClick("Notifications")}
                >
                  <i
                    className="bi bi-bell"
                    style={{
                      width: "30px",
                      height: "30px",
                      borderRadius: "50%",
                      backgroundColor: darkMode ? "#F0F0F0" : "#F0F0F0",
                      color: darkMode ? "#333" : "#333", // Icon color changes by theme
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "18px",
                      transition: "all 0.3s ease",
                    }}
                  ></i>

                  {unreadCount > 0 && (
                    <span
                      className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                      style={{
                        fontSize: "10px",
                        fontWeight: "bold",
                        padding: "2px 5px",
                        minWidth: "16px",
                      }}
                    >
                      {unreadCount}
                    </span>
                  )}
                </Link>
              )}

              {/* Profile button  */}
              <div className="position-relative" ref={profileMenuRef}>
                <button
                  className="p-0 border-0 bg-transparent"
                  onClick={toggleProfileMenu}
                  title="Profile"
                >
                  {user?.user_profile_pic ? (
                    <img
                      src={`${
                        process.env.REACT_APP_SERVER_URL
                      }/${user.user_profile_pic.replace(/\\/g, "/")}`}
                      alt="Profile"
                      className="rounded-circle shadow border"
                      style={{
                        width: "28px",
                        height: "28px",
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    <div
                      className="rounded-circle bg-dark text-white d-flex align-items-center justify-content-center"
                      style={{
                        width: "25px",
                        height: "25px",
                        fontSize: "12px",
                      }}
                    >
                      {user?.user_name?.charAt(0).toUpperCase() || "U"}
                    </div>
                  )}
                </button>

                {showProfileMenu && (
                  <div
                    className="dropdown-menu show profile-dropdown"
                    onMouseLeave={closeMenu}
                  >
                    {/* Share Chat (only mobile view) */}
                    {(isChatPage ||
                      location.pathname.includes("/chat/document")) && (
                      <button
                        className="dropdown-item profile-dropdown-item gap-3 d-flex align-items-center d-md-none"
                        onClick={() => {
                          handleShareSession();
                          closeMenu();
                        }}
                      >
                        <img
                          src={sharIcon}
                          alt="Share"
                          style={{ width: "18px", height: "18px" }}
                          className="profile-i"
                        />
                        <span className="Profile-text">Share Chat</span>
                      </button>
                    )}

                    {/* Theme */}
                    <button
                      className="dropdown-item profile-dropdown-item d-flex align-items-center gap-3 d-md-none "
                      onClick={toggleDarkMode}
                    >
                      <i
                        className={`bi  ${darkMode ? "bi-sun" : "bi-moon"} `}
                        aria-hidden="true"
                      ></i>
                      <span className="Profile-text">
                        {darkMode
                          ? "Switch to Light Mode"
                          : "Switch to Dark Mode"}
                      </span>
                    </button>

                    {/*  Settings */}
                    <Link
                      className="dropdown-item profile-dropdown-item gap-3 d-flex align-items-center"
                      to="profile"
                      onClick={() => {
                        closeMenu(); // first action
                        handleMenuClick("Settings"); // second action
                      }}
                    >
                      {/* <i className="bi bi-gear profile-i"></i> */}
                      <img
                        src={settingIcon}
                        alt="offlineIcon"
                        style={{ width: "18px", height: "15px" }}
                        className="icon-image"
                      />
                      <span className="Profile-text">Settings</span>
                    </Link>

                    {/*  Help */}
                    <Link
                      className="dropdown-item profile-dropdown-item gap-3 d-flex align-items-center"
                      to="getHelpPage"
                      onClick={() => {
                        closeMenu(); // First Action
                        handleMenuClick("Get Help"); // Second Action
                      }}
                    >
                      {/* <i className="bi bi-question-circle profile-i"></i> */}
                      <img
                        src={helpIcon}
                        alt="offlineIcon"
                        style={{ width: "18px", height: "15px" }}
                        className="icon-image"
                      />
                      <span className="Profile-text">Get Help</span>
                    </Link>

                    {/* Notifications */}
                    {unreadCount > 0 ? (
                      <Link
                        className="dropdown-item profile-dropdown-item gap-3 d-flex align-items-center position-relative d-md-none"
                        to="notifications"
                        onClick={closeMenu}
                      >
                        {/* <i className="bi bi-bell profile-i"></i> */}
                        <img
                          src={notificationIcon}
                          alt="offlineIcon"
                          style={{ width: "18px", height: "15px" }}
                          className="icon-image"
                        />
                        <span className="Profile-text">Notifications</span>
                        <span className="notification-badge">
                          {unreadCount}
                        </span>
                      </Link>
                    ) : (
                      <div
                        className="dropdown-item profile-dropdown-item gap-3 d-flex align-items-center position-relative d-md-none text-muted"
                        style={{ cursor: "default" }}
                      >
                        {/* <i className="bi bi-bell profile-i"></i> */}
                        <img
                          src={notificationIcon}
                          alt="offlineIcon"
                          style={{ width: "18px", height: "15px" }}
                          className="icon-image"
                        />
                        <span className="Profile-text  refresh-prompts">
                          No notifications
                        </span>
                      </div>
                    )}

                    {/*  Logout */}
                    <button
                      className="dropdown-item profile-dropdown-item gap-3 d-flex align-items-center"
                      onClick={() => {
                        handleLogout();
                        closeMenu();
                      }}
                    >
                      {/* <i className="bi bi-box-arrow-right profile-i"></i> */}
                      <img
                        src={logoutIcon}
                        alt="offlineIcon"
                        style={{ width: "18px", height: "15px" }}
                        className="icon-image"
                      />
                      <span className="Profile-text">Log Out</span>
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </nav>

      {/* Share Modal */}
      {showShareModal && (
        <div className="modal-backdrop-custom">
          <div className="share-modal position-relative">
            <img
              src={crossIcon}
              alt="Close"
              className="custom-close-icon icon-image"
              onClick={() => {
                setShowShareModal(false);
                setShowMailIcon(false);
                setCopyStatus("idle");
              }}
            />
            <h5 className="mb-4 refresh-prompts mt-4">
              Share your conversation
            </h5>
            <button
              className="rounded share-button w-100 mb-4 d-flex justify-content-center align-items-center fw-semibold p-1"
              onClick={async () => {
                if (copyStatus === "copied") return;
                setCopyStatus("copying");
                await navigator.clipboard.writeText(generatedLink);
                setCopyStatus("copied");
                setShowMailIcon(true);
              }}
              disabled={
                !generatedLink ||
                copyStatus === "copying" ||
                copyStatus === "copied"
              }
            >
              <span
                className="spinner-container"
                style={{ width: "16px", height: "16px" }}
              >
                {copyStatus === "copying" && (
                  <span className="spinner-border spinner-border-sm textwhite" />
                )}
              </span>
              <span>
                {copyStatus === "copied"
                  ? "Link Copied!"
                  : copyStatus === "copying"
                  ? "Copying..."
                  : "Copy Link"}
              </span>
            </button>
            {showMailIcon && (
              <div className="share-mail-icon">
                <img
                  src={mailIcon}
                  alt="Send via Email"
                  title="Send via Email"
                  style={{ width: "30px", height: "30px", cursor: "pointer" }}
                  onClick={() => {
                    const mailURL = `https://mail.google.com/mail/?view=cm&fs=1&to=&su=Chat Session Link&body=Here is the session link: ${generatedLink}`;
                    window.open(mailURL, "_blank");
                  }}
                />
              </div>
            )}
          </div>
        </div>
      )}

      {/* Conformation model */}
      {showModelConfirmation && selectedModelDetails && (
        <div className="modal modal-backdrop-custom d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              {/* Close Button */}
              <div
                style={{
                  width: "45px",
                  height: "45px",
                  borderRadius: "50%",
                  margin: "0 auto",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "var(--border-color)",
                }}
                className="text-center rounded-6 p-2  mt-3 mb-2"
              >
                <img
                  src={likeIcon}
                  style={{
                    width: "25px",
                    height: "25px",
                  }}
                  className="icon-image"
                  alt="Close"
                />
              </div>
              <button
                type="button"
                className="modal-close-btn position-absolute top-0 end-0 mt-2 me-2"
                onClick={() => setShowModelConfirmation(false)}
                aria-label="Close"
              >
                <img
                  src={crossIcon}
                  className="icon-image cross-i"
                  alt="Close"
                />
              </button>

              {/* Modal Body */}
              <div className="text-center">
                <p className="fw-bold mt-2 mb-3 refresh-prompts">
                  Excellent choice !
                </p>

                <div className="border rounded-3 p-3 mt-3 text-start">
                  {/* Model Name */}
                  <p
                    className="text-truncate mb-2 refresh-prompts"
                    title={
                      selectedModelDetails.model_details?.model_generic_name ||
                      selectedModelDetails.name
                    }
                  >
                    <strong className="refresh-prompts">Model Name: </strong>
                    {selectedModelDetails.model_details?.model_generic_name ||
                      selectedModelDetails.name}
                  </p>

                  {/* <hr className="my-2" /> */}

                  {/* Industry */}
                  <p
                    className="text-truncate mb-2 refresh-prompts"
                    title={
                      selectedModelDetails.model_details?.model_industry ||
                      "N/A"
                    }
                  >
                    <strong className="refresh-prompts">Industry: </strong>
                    {selectedModelDetails.model_details?.model_industry ||
                      "N/A"}
                  </p>

                  {/* <hr className="my-2" /> */}

                  {/* Description */}
                  <p className="fw-bold  mb-2 refresh-prompts">Description:</p>
                  <p
                    title={
                      selectedModelDetails.model_details
                        ?.model_user_description || "No description available."
                    }
                    className="refresh-prompts model-d"
                    style={{
                      display: "-webkit-box",
                      WebkitLineClamp: 5,
                      WebkitBoxOrient: "vertical",
                      textAlign: "justify",
                      height: "90px",
                      overflowY: "scroll",
                    }}
                  >
                    {selectedModelDetails.model_details
                      ?.model_user_description || "No description available."}
                  </p>
                </div>
              </div>

              {/* Modal Footer */}
              <div className="modal-footer justify-content-center">
                <button
                  type="button"
                  className="px-5 rounded custom-btn border-none py-2 fw-bold refresh-prompts"
                  onClick={() => setShowModelConfirmation(false)}
                >
                  Ok
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Privacy Modal */}
      {/* {showPrivacyModal && (
        <div className="modal modal-backdrop-custom d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="document-modal modal-content text-center">

              <div className="modal-header justify-content-center position-relative">
                <button
                  type="button"
                  className="modal-close-btn"
                  onClick={() => setShowPrivacyModal(false)}
                  aria-label="Close"
                >
                  <img
                    src={crossIcon}
                    className="icon-image1 cross-i"
                    alt="Close"
                  />
                </button>
              </div>

     
              <div className="modal-body mt-2" style={{ padding: "20px" }}>
                <div
                  className="rounded-circle d-flex justify-content-center align-items-center p-3 mb-3"
                  style={{
                    width: "60px",
                    height: "60px",
                    backgroundColor: "#E3E6EA",
                    margin: "0 auto",
                  }}
                >
                  <i
                    className={`bi ${
                      isFullPrivacy ? "bi-shield-lock" : "bi-shield-exclamation"
                    } fs-3`}
                  ></i>
                </div>

                <h5 className="fw-bold refresh-prompts mb-3">
                  {isFullPrivacy
                    ? "Switch to Zero Privacy Mode?"
                    : "Switch to Full Privacy Mode?"}
                </h5>

          
                <p className="refresh-prompts">
                  Switching to privacy mode will end your current session and
                  start a new chat. Do you want to continue?
                </p>
              </div>

        
              <div className="modal-footer justify-content-center mb-3 gap-3">
                <button
                  className="cancle-btn1 w-25"
                  onClick={() => setShowPrivacyModal(false)}
                >
                  Cancel
                </button>
                <button
                  className="custom-btn w-25"
                  onClick={() => {
                    setShowPrivacyModal(false);
                    dispatch(togglePrivacyMode());

                    // Navigate to new page without hard reload
                    navigate("/user/new");
                    handleMenuClick("New Chat");
                    navigate(0);
                    updateUserPreferences({ privacy_mode: !isFullPrivacy });

                    showSuccessToast(
                      isFullPrivacy
                        ? TOAST_MESSAGES.PRIVACY_MODE_OFF
                        : TOAST_MESSAGES.PRIVACY_MODE_ON
                    );
                  }}
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      )} */}
    </div>
  );
};

export default TopBar;
